import enviro from 'enviro';
var ENV;
(function (ENV) {
  ENV["PROD"] = "PROD";
  ENV["QA"] = "QA";
})(ENV || (ENV = {}));
const EPIC_APP_IDS = {
  [ENV.QA]: 32764755,
  [ENV.PROD]: 40104170
};
const getCurrentEnv = () => enviro.isQa() ? ENV.QA : ENV.PROD;
export const getEpicAppId = () => EPIC_APP_IDS[getCurrentEnv()];
export const isEpicApp = appId => appId === getEpicAppId();